export default __webpack_public_path__ + "media/51dc0586e395b90286692bc49a68a13c2fdce279e60b6525737792973725a36a.svg";